import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import TextField from "@mui/material/TextField";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ORG_TITLE_URL } from "../../../Constants/Constants";
import AxiosInstance from "../../../services/AxiosInstance";
import { ThemeProvider } from "../../v2/home/theme/ThemeProvider";
import { useAlert } from "./../../alerts/AlertContext";
import AddTaskIcon from "@mui/icons-material/AddTask";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

function OrgTitleDialog({
  editOrgTitleId,
  selectedOrgTitleId,
  orgTitleName,
  callOrgTitles,
  isEdit
}) {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(true);
  const [name, setName] = useState("");
  const showAlert = useAlert();

  const handleClickOpen = () => {
    if (isEdit === true) {
      getOrgTitle();
    } else {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleActiveChange = (event) => {
    setActive(event.target.value);
  };

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handleSave = () => {
    const payload = {};
    payload.name = name;
    payload.active = active;
    if (isEdit) {
      updateOrgTitle(payload);
    } else {
      saveOrgTitle(payload);
    }
  };

  const saveOrgTitle = (payload) => {
    AxiosInstance.post(ORG_TITLE_URL, payload)
      .then((response) => {
        setActive(true);
        showAlert("Organization Title created successfully!", "success");
        callOrgTitles();
      })
      .catch((error) => {
        showAlert("Organization Title creation failed!", "error");
        console.error(error);
      });
  };

  const updateOrgTitle = (payload) => {
    AxiosInstance.put(`${ORG_TITLE_URL}/${editOrgTitleId}`, payload)
      .then((response) => {
        setActive(true);
        showAlert("Organization Title updated successfully!", "success");
        callOrgTitles();
      })
      .catch((error) => {
        showAlert("Organization Title updation failed!", "error");
        console.error(error);
      });
  };

  const getOrgTitle = () => {
    AxiosInstance.get(`${ORG_TITLE_URL}/${editOrgTitleId}`).then((response) => {
      var orgTitleData = response.data.data;
      setName(orgTitleData.name);
      setActive(orgTitleData.active);
      setOpen(true);
    });
  };
  return (
    <ThemeProvider>
      <React.Fragment>
        {editOrgTitleId === "" ? (
          <>          
          < Tooltip
            title="Add Organization Title"
            onClick={handleClickOpen}
            style={{ cursor: "pointer", margin: "2px", float: "right" }}
          >
            <IconButton>
              <AddTaskIcon color="primary" />
            </IconButton>
          </Tooltip>
          </>
  ) : (
    <Link onClick={handleClickOpen}>{orgTitleName}</Link>
        )
}

<Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{
            sx: {
              width: 300, // fixed width
              height: 300, // fixed height
              maxWidth: "100%", // optional for responsiveness
              maxHeight: "100%", // optional to prevent overflow
            },
            component: "form",
            onSubmit: (event) => {
              event.preventDefault();
              const formData = new FormData(event.currentTarget);
              const formJson = Object.fromEntries(formData.entries());
              const name = formJson.name;
              console.log(name);
              handleSave();
              handleClose();
            },
          }}
        >
          <DialogTitle>Add Organization Title</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              required
              margin="dense"
              id="rg"
              name="name"
              label="Organization Title"
              type="text"
              fullWidth
              value={name}
              variant="outlined"
              onChange={handleNameChange}
            />
            <br />
            <br />
            <FormControl>
              <FormLabel id="demo-row-radio-buttons-group-label">
                Active
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={active}
                onChange={handleActiveChange}
              >
                <FormControlLabel
                  value={true}
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  value={false}
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button type="submit">Add </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment >
    </ThemeProvider >
  );
}
export default OrgTitleDialog;
